import * as ambassadorWixEcomV1TotalsCalculation from './ecom-v1-totals-calculation-totals-calculator.http.js';
import * as ambassadorWixEcomV1TotalsCalculationTypes from './ecom-v1-totals-calculation-totals-calculator.types.js';
import * as ambassadorWixEcomV1TotalsCalculationUniversalTypes from './ecom-v1-totals-calculation-totals-calculator.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function calculateTotals(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1TotalsCalculationUniversalTypes.CalculateTotalsRequest,
  ambassadorWixEcomV1TotalsCalculationTypes.CalculateTotalsRequest,
  ambassadorWixEcomV1TotalsCalculationUniversalTypes.CalculateTotalsResponse &
    ambassadorWixEcomV1TotalsCalculationUniversalTypes.CalculateTotalsResponseNonNullableFields,
  ambassadorWixEcomV1TotalsCalculationTypes.CalculateTotalsResponse &
    ambassadorWixEcomV1TotalsCalculationTypes.CalculateTotalsResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1TotalsCalculation.calculateTotals(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/calculate-totals',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
